import { useEffect } from "react";
import { RouterProvider, type RegisteredRouter } from "@tanstack/react-router";
import { useAuthStore } from "../shared/stores/authStore";
import styles from "./App.module.scss";
import { ToastContainer } from "@/shared/ui";
import { GlobalModals } from "@/widgets/GlobalModals";
import { useInvitesStore } from "@/shared/stores/invitesStore";

function AppContent({ router }: { router: RegisteredRouter }) {
  const { isLoading, profile, authenticate } = useAuthStore();
  const { fetchInvites } = useInvitesStore();

  useEffect(() => {
    authenticate();
  }, [authenticate]);

  useEffect(() => {
    const webApp = window.Telegram?.WebApp;
    if (webApp && !webApp.isExpanded && typeof webApp.expand === "function") {
      webApp.expand();
    }
  }, []);

  useEffect(() => {
    if (!isLoading && profile) {
      fetchInvites();
    }
  }, [isLoading, profile, fetchInvites]);

  if (isLoading) {
    return (
      <div className={styles.loadingOverlay}>
        <div className={styles.spinner}></div>
        <p className={styles.loadingText}>Авторизация...</p>
      </div>
    );
  }

  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export function App({ router }: { router: RegisteredRouter }) {
  return (
    <>
      <AppContent router={router} />
      <GlobalModals />
      <ToastContainer />
    </>
  );
}
